import React from "react";
import HeroSection from "./SECTIONS/HERO";
import StatisticsSection from "./SECTIONS/STATS";
import PartnersCarousel from "./SECTIONS/PARTNERS";
import AudienceSwitcher from "./SECTIONS/AUDIENCES";
import Difference from "./SECTIONS/DIFFERENCE";
import Lifecycle from "./SECTIONS/LIFECYCLE";
import Capabilities from "./SECTIONS/CAPABILITIES";
import Network from "./SECTIONS/NETWORK";
import Therapeutic from "./SECTIONS/THERAPEUTIC";
import People from "./SECTIONS/PEOPLE";
import Insights from "./SECTIONS/INSIGHTS";
import FinalCta from "./SECTIONS/CTA";
import useDocumentMeta from "../../UTILS/HOOKS/useDocumentMeta";

const HomePage = () => {
  useDocumentMeta({
    title: "KUR Research | Integrated Clinical Research Site Network",
    description:
      "KUR Research is an integrated clinical research site network partnering with community-based practices to bring diverse patient populations to clinical trials.",
    path: "/",
  });

  return (
    <>
      <HeroSection />
      <StatisticsSection />
      <PartnersCarousel />
      <AudienceSwitcher />
      <Difference />
      <Lifecycle />
      <Capabilities />
      <Network />
      <Therapeutic />
      <People />
      <Insights />
      <FinalCta />
    </>
  );
};

export default HomePage;
